module.exports = __webpack_public_path__ + "img/logo-app.1d3124ee.png";